var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deployed-workload-control',{staticClass:"mt-6 ml-6 mr-6"})
}
var staticRenderFns = []

export { render, staticRenderFns }